/**
 *
 * @param cellWidth Width of the heading content
 * @param tableWidth Width of the table
 * @param gap Gap between table headings/cells
 */
function calcPercent(cellWidth: number, tableWidth: number, gap = 34) {
  const ratio = 1 / tableWidth;
  const cellSize = cellWidth + gap;
  return ratio * cellSize * 100;
}
export function makeCalc(
  tableWidth: number,
  gap: number,
): (cellWidth: number, gap?: number) => number {
  return (cellWidth: number, _gap = gap) => {
    return calcPercent(cellWidth, tableWidth, _gap);
  };
}
